import Ajax from "../../avernus/ajax/Ajax";
import { TStorage } from "../../avernus/tstorage/TStorage";
import Config from "../Config";
import { IPermisionForInterface } from "../interfaces/IPermission";
import { Url } from "../../avernus/url/source/Url";
import DateTool from "../../avernus/datetool/source/DateTool";
import { Order } from "../components/user/Order";
declare var device:any;

interface ICheckCb{
    (valid:boolean):void
}

interface ICheckResult{
    tokenError:boolean
    api_token:string
    permission:string
    restaurants:Array<IRestaurant>
}
interface IRestaurant{
    id  : number
    name: string
}
interface IUser{
    id  : number
    name: string
}


interface IUserPosition{
    latitude : number
    longitude: number
}

export class Api{
    static token                : string;
    static currentRestaurant    : IRestaurant;
    static restaurants          : Array<IRestaurant>;
    static user                 : IUser;
    static permission           : IPermisionForInterface;
    static userCountry          : string;
    static userState            : string;
    static navigateToProfilPage : boolean;
    static userPostition        : IUserPosition;


    public static cleanStorage(){
        Url.emptyAll();
        this.setPermission(undefined);
        this.setToken(undefined);
        this.setUser(undefined);
        this.setRestaurants([]);
        this.setCurrentRestaurant(null);
        new TStorage().set('name', undefined);
        this.userCountry        = '';
        this.userState          = '';
        this.userPostition      = null;
    }


    public static setPermission(permission:IPermisionForInterface):void {
        let Storage = new TStorage();
        Storage.set('api_permission', permission);
        this.permission = permission;
    }

    public static setRestaurants(restaurants:Array<IRestaurant>):void {
        let Storage              = new TStorage();
        Storage.set('restaurants', restaurants);
        if ( Storage.get('currentRestaurant', undefined) === undefined ) { // if undefined
            Storage.set('currentRestaurant', null);
        }

        this.restaurants         = restaurants;
        this.currentRestaurant   = null;
        if ( restaurants[0] !== undefined ) {
            if ( Storage.get('currentRestaurant', null) === null ) { // if null
                this.setCurrentRestaurant(restaurants[0]);
            }

        }
    }

    public static getRestaurants():Array<IRestaurant> {
        let Storage             = new TStorage();
        this.restaurants        = Storage.get('restaurants', []);
        return this.restaurants;
    }

    public static setUser(user:IUser):void {
        let Storage              = new TStorage();
        Storage.set('user', user);
        this.user         = user;
    }

    public static getUser():IUser {
        let Storage             = new TStorage();
        this.user               = Storage.get('user', null);
        return this.user;
    }

    public static setCurrentRestaurant(rest:IRestaurant):IRestaurant {
        let Storage              = new TStorage();
        Storage.set('currentRestaurant', rest);
        return this.currentRestaurant=rest;
    }

    public static getCurrentRestaurant():IRestaurant {
        let Storage             = new TStorage();
        this.currentRestaurant  = Storage.get('currentRestaurant', null);
        return this.currentRestaurant;
    }

    public static getPermission():IPermisionForInterface{
        let Storage      = new TStorage();
        this.permission = Storage.get('api_permission', 'guest');
        if ( this.permission ===  undefined ) {
            this.permission = 'guest';
        }
        return this.permission;
    }

    public static setToken(api_token: string):void {
        let Storage = new TStorage();
        Storage.set('api_token', api_token);
        this.token = api_token;
    }

    public static getToken():string{
        let Storage = new TStorage();
        let token   = Storage.get('api_token', undefined);
        this.token = token;
        return this.token;
    }

    public static getServerRouteUrl():string{
        return Config.getApiUrl();
    }

    private static getServerUrl():string{
        return this.getServerRouteUrl()+'/api';
    }

    public static check(cb:ICheckCb){
        if ( this.getToken() === undefined ) {
            cb(false);
            return;
        }

        this.call('/check', {}, (ret:ICheckResult) =>{
            let tokenError:boolean = ret.tokenError===undefined?true:false;
            if ( tokenError === false && ret.restaurants !== undefined ) {
                // NOTE: Később
                // this.setToken(ret.api_token);
                this.setPermission(ret.permission as IPermisionForInterface);
                this.setRestaurants(ret.restaurants);
            }
            cb(tokenError);
        });
    }

    public static call(url:string, data:any, cb:Function) {
        if ( this.getToken() !== undefined ) {
            data.api_token  = this.getToken();
            data.clientTime = DateTool.getDateTime();
        }
        new Ajax((this.getServerUrl()+url).replace('//api/','/api/'), 'post', data, (ret:any) =>{
            if ( url !== '/check' && Url.getUrl() !== 'login' && ret.tokenError !== undefined && ret.tokenError === true ) {
                // alert('You are signed in from another device!');
                if ( device.platform === 'iOS' || device.platform === 'Android' ) {
                    try {
                        (window as any).redirectToLogin();
                    } catch (error) {}
                }else{
                    window.location.href = '/login';
                }
            }else{
                cb(ret);
            }
        });
    }

    public static getGeoLocation(cb:IgetGeoLocationCb){
        if (this.getUserPosition() !== null ) {
            // FIXME: itt jartam, rosszul adom vissza
            console.log({
                coords: this.getUserPosition()
            }, 'userPostition');
            cb({
                coords: this.getUserPosition()
            });
            return;
        }
        if ( navigator.geolocation ) {
            try {
                navigator.geolocation.getCurrentPosition((position)=>{
                    this.userPostition = {
                        latitude    : position.coords.latitude,
                        longitude   : position.coords.longitude
                    };
                    if ( this.getUserCountry() === '' ) {
                        this.getUserCountryAndState(position, (position)=>{
                            cb(position);
                        });
                    }else{
                        cb(position);
                    }
                },()=>{
                    cb(null);
                });
            } catch (error) {
                cb(null);
            }
        }else{
            cb(null);
        }
    }


    private static getUserCountryAndState(position:any, cb:IgetGeoLocationCb){
        Api.call('/getNerlyCity', {
            latitude:  position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString(),
            apiKey:    Config.getAPIKey()
        }, (result)=>{
            if ( result.results !== undefined  && result.results.length > 0  && result.results[0].address_components !== undefined ) {
                var address_components = result.results[0].address_components;
                for (var key in address_components) {
                    var item = address_components[key];
                    if ( item.types.indexOf('country') === 0) {
                        this.userCountry = item.long_name;
                    }
                    if ( item.types.indexOf('state') === 0) {
                        this.userState   = item.long_name;
                    }
                }
            }
            cb(position);
        });
    }

    public static getUserPosition():IUserPosition {
        return this.userPostition===undefined?null:this.userPostition;
    }
    public static getUserCountry():string{
        return this.userCountry===undefined?'':this.userCountry;
    }

    public static getUserState():string{
        return this.userState===undefined?'':this.userState;
    }

    public static setNavigateToProfilPage(enabled:boolean):void{
        this.navigateToProfilPage = enabled;
    }

    public static isEnabledNavigateToProfilPage():boolean{
        return this.navigateToProfilPage===undefined?false:this.navigateToProfilPage;
    }

    public static openInMap(restaurant_latitude:string, restaurant_longitude:string, label:string){
        var geocoords = restaurant_latitude + ',' + restaurant_longitude;
        if (device.platform.toUpperCase() === 'IOS' ) {
            // window.open('maps://?q=' + geocoords, '_system');
            cordova.InAppBrowser.open('maps://?q=' + geocoords, '_system');
        }else {
            var label = encodeURI(label); // encode the label!
            window.open('geo:0,0?q=' + geocoords + '(' + label + ')', '_system');
        }
    }

    public static refreshCurrentRestaurant(id:number, reloadPage:boolean=true):void{
        let restaurants = Api.getRestaurants();
        for (var key in restaurants) {
            var item = restaurants[key];
            if ( item.id === id ) {
                Api.setCurrentRestaurant(item);
                if ( reloadPage === true ) {
                    window.location.reload();
                }
                return;
            }
        }
    }

    public static isFrontUser():boolean {
        return Api.getPermission() === 'user';
    }

    public static OTPSimpleModulePermissionEnabled():boolean {
        let perm = Api.getPermission();
        return (perm === 'admin' || perm === 'superadmin' || perm === 'simple_operator');
    }

    public static getGuestRedirectUrl():string {
        if ( Order.getOffers().length > 0 ) {
            return '/user/payment';
        }
        return '/user/offers';
    }
}

interface IgetGeoLocationCb{
    (position:any):void
}
